import { Link } from "react-router";
import { MAIN_NAV } from "../../Config/nav";
import { Container, Nav, Navbar } from "react-bootstrap";
import LoginNavLink from "../Auth/LoginNavLink";
import AdminNavLink from "./AdminNavLink";

export default function TopNav({ hasAuth = false }: { hasAuth?: boolean }) {
  return (
    <div className="top-nav">
      <Navbar expand="lg" variant="dark" bg="dark">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src="/images/logo-stacked.svg"
              alt="Liberty Connect Logo"
              className="logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end"
          >
            <Nav>
              {MAIN_NAV.map((nav) => (
                <Nav.Link to={nav.link} as={Link} key={nav.label}>
                  {nav.label}
                </Nav.Link>
              ))}
              {hasAuth ? <AdminNavLink /> : null}
              {hasAuth ? <LoginNavLink /> : null}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
